import { render, staticRenderFns } from "./announcementList.vue?vue&type=template&id=0d3c85f0&scoped=true&"
import script from "./announcementList.vue?vue&type=script&lang=js&"
export * from "./announcementList.vue?vue&type=script&lang=js&"
import style0 from "./announcementList.vue?vue&type=style&index=0&id=0d3c85f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3c85f0",
  null
  
)

export default component.exports